import { render, staticRenderFns } from "./BestAthletesEventOrderAdmin.vue?vue&type=template&id=5638eb10&scoped=true&"
import script from "./BestAthletesEventOrderAdmin.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventOrderAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./BestAthletesEventOrderAdmin.vue?vue&type=style&index=0&id=5638eb10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638eb10",
  null
  
)

export default component.exports